/**
 * The `evaluation` for a result with a pose. A FastSAM3D result sends its `mhr` block alone (the backend derives the
 * landmarks from it), and goes again as `poseRepeat` once sent (`lastSent`): a 30 Hz tick over a 15 fps stream.
 */
export function poseEvaluation(result, lastSent, payload) {
  if (!result.mhr) {
    return { poseLandmarks: result.landmarks[0], ...payload };
  }
  if (result === lastSent) {
    return { poseRepeat: true, ...payload };
  }
  return { mhr: result.mhr, ...payload };
}
